import { useEffect } from "react";

export function SuggestionModal() {
  useEffect(() => {
    const openBtns = document.querySelectorAll(".js-rp-suggestion-open");
    const modal = document.getElementById("rpSuggestionModal") as HTMLElement | null;
    if (!openBtns.length || !modal) return;
    const closeBtn = document.getElementById("rpSuggestionClose");
    const cancelBtn = document.getElementById("rpSuggestionCancel");
    const form = document.getElementById("rpSuggestionForm") as HTMLFormElement | null;
    const feedback = document.getElementById("rpSuggestionFeedback");
    const submitBtn = document.getElementById("rpSuggestionSubmit") as HTMLButtonElement | null;

    function setFeedback(text: string, kind?: string) {
      if (!feedback) return;
      feedback.textContent = text || "";
      feedback.className = "rp-suggestion-feedback" + (kind ? " is-" + kind : "");
    }

    function open() {
      modal!.hidden = false;
      document.body.style.overflow = "hidden";
      setTimeout(() => {
        const t = document.getElementById("rpSuggestionTitulo") as HTMLInputElement | null;
        t?.focus();
      }, 30);
    }
    function close() {
      modal!.hidden = true;
      document.body.style.overflow = "";
      setFeedback("", "");
    }

    const openers = Array.from(openBtns);
    openers.forEach((btn) => btn.addEventListener("click", open));
    closeBtn?.addEventListener("click", close);
    cancelBtn?.addEventListener("click", close);

    const onOverlay = (e: MouseEvent) => {
      if (e.target === modal) close();
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape" && !modal!.hidden) close();
    };
    modal.addEventListener("click", onOverlay);
    document.addEventListener("keydown", onKey);

    const onSubmit = (e: Event) => {
      e.preventDefault();
      if (!form) return;
      const titulo = (document.getElementById("rpSuggestionTitulo") as HTMLInputElement | null)?.value || "";
      const descricao = (document.getElementById("rpSuggestionDescricao") as HTMLTextAreaElement | null)?.value || "";
      if (!titulo.trim() || !descricao.trim()) {
        setFeedback("Título e descrição são obrigatórios.", "error");
        return;
      }

      setFeedback("Enviando…", "pending");
      if (submitBtn) submitBtn.disabled = true;

      const fd = new FormData(form);
      fetch("/ajax/ajax-suggestion.php", {
        method: "POST",
        body: fd,
        credentials: "same-origin",
      })
        .then((r) => r.json().then((j) => ({ ok: r.ok, status: r.status, j })))
        .then((res) => {
          if (submitBtn) submitBtn.disabled = false;
          if (res.ok && res.j && res.j.success) {
            setFeedback("Sugestão enviada com sucesso. Obrigado!", "success");
            form.reset();
            setTimeout(close, 1600);
            return;
          }
          const msg = (res.j && (res.j.message || res.j.error)) || "Erro " + res.status;
          setFeedback("Não foi possível enviar: " + msg, "error");
        })
        .catch(() => {
          if (submitBtn) submitBtn.disabled = false;
          setFeedback("Falha de rede. Tente novamente.", "error");
        });
    };
    form?.addEventListener("submit", onSubmit);

    return () => {
      openers.forEach((btn) => btn.removeEventListener("click", open));
      closeBtn?.removeEventListener("click", close);
      cancelBtn?.removeEventListener("click", close);
      modal.removeEventListener("click", onOverlay);
      document.removeEventListener("keydown", onKey);
      form?.removeEventListener("submit", onSubmit);
    };
  }, []);

  return (
    <div
      className="rp-modal-overlay"
      id="rpSuggestionModal"
      hidden
      role="dialog"
      aria-modal="true"
      aria-labelledby="rpSuggestionTitle"
    >
      <div className="rp-modal">
        <div className="rp-modal-head">
          <h2 className="rp-modal-title" id="rpSuggestionTitle">
            <i className="fas fa-lightbulb" aria-hidden="true"></i>
            Enviar sugestão
          </h2>
          <button type="button" className="rp-modal-close" id="rpSuggestionClose" aria-label="Fechar">
            &times;
          </button>
        </div>
        <form className="rp-modal-body rp-suggestion-form" id="rpSuggestionForm" noValidate>
          <p className="rp-modal-hint">Tem uma ideia para melhorar o Radios.PRO? Envie sua sugestão.</p>
          <div className="rp-form-group">
            <label htmlFor="rpSuggestionTitulo">
              Título <span className="rp-required">*</span>
            </label>
            <input type="text" id="rpSuggestionTitulo" name="titulo" maxLength={200} required />
          </div>
          <div className="rp-form-group">
            <label htmlFor="rpSuggestionDescricao">
              Descrição <span className="rp-required">*</span>
            </label>
            <textarea id="rpSuggestionDescricao" name="descricao" rows={5} maxLength={4000} required />
          </div>
          <div className="rp-form-row">
            <div className="rp-form-group">
              <label htmlFor="rpSuggestionNome">
                Nome <span className="rp-optional">(opcional)</span>
              </label>
              <input type="text" id="rpSuggestionNome" name="nome" maxLength={120} />
            </div>
            <div className="rp-form-group">
              <label htmlFor="rpSuggestionEmail">
                E-mail <span className="rp-optional">(opcional)</span>
              </label>
              <input type="email" id="rpSuggestionEmail" name="email" maxLength={200} />
            </div>
          </div>
          <div className="rp-suggestion-feedback" id="rpSuggestionFeedback" role="status" />
          <div className="rp-modal-actions">
            <button type="button" className="rp-btn rp-btn--ghost" id="rpSuggestionCancel">
              Cancelar
            </button>
            <button type="submit" className="rp-btn rp-btn--primary" id="rpSuggestionSubmit">
              <i className="fas fa-paper-plane" aria-hidden="true"></i>
              Enviar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
